import { ReactNode } from "react";
import { Typography } from '@mui/material';
import CSS from 'csstype';

import { classNames } from "~/utils/utils";

import "./style.less";

interface IMyTitle {
	children?: ReactNode;
	className?: string;
	sx?: CSS.Properties;
}

export default function MyTitle({
	children = null,
	className = "",
	sx = {},
}: IMyTitle) {
	return <Typography variant="h6" component="div" className={classNames(["myTitle", className])} sx={ sx }>
		{ children }
	</Typography>;
}
